// Trimmed port of the mill's incentive palette (pages/incentive/constants/colors.ts)
export type ColorPair = { bg: string; text: string };

export interface SixZoneThresholds {
	Red: number;
	Orange: number;
	Yellow: number;
	GreenSoft: number;
	GreenNormal: number;
	GreenHard: number;
}

export const DEFAULT_INCENTIVE_THRESHOLDS: SixZoneThresholds = {
	Red: 0,
	Orange: 40,
	Yellow: 60,
	GreenSoft: 75,
	GreenNormal: 85,
	GreenHard: 95,
};

export const GRAY_COLOR: ColorPair = { bg: "#e0e0e0", text: "#757575" };

const ZONE_COLORS: ColorPair[] = [
	{ bg: "#2E7D32", text: "#fff" },
	{ bg: "#4CAF50", text: "#fff" },
	{ bg: "#8BC34A", text: "#fff" },
	{ bg: "#FFC107", text: "#333" },
	{ bg: "#FF9800", text: "#333" },
	{ bg: "#F44336", text: "#fff" },
];

export const getZoneColor = (
	value: number | null,
	t: SixZoneThresholds,
): ColorPair => {
	if (value == null) return GRAY_COLOR;
	if (value >= t.GreenHard) return ZONE_COLORS[0];
	if (value >= t.GreenNormal) return ZONE_COLORS[1];
	if (value >= t.GreenSoft) return ZONE_COLORS[2];
	if (value >= t.Yellow) return ZONE_COLORS[3];
	if (value >= t.Orange) return ZONE_COLORS[4];
	return ZONE_COLORS[5];
};

export const SURFACE = {
	border: "#e0e0e0",
	borderLight: "#ccc",
	background: "#fafafa",
	paper: "#fff",
} as const;
